import uniq from "lodash/uniq"

const words = uniq([
  "ace",
  "amazing",
  "astonishing",
  "astounding",
  "awe",
  "awe-inspiring",
  "awesome",
  "badass",
  "beautiful",
  "best",
  "brilliant",
  "celebrate",
  "cheer",
  "clap",
  "classy",
  "confetti",
  "cool",
  "dance",
  "dazzling",
  "delightful",
  "dope",
  "epic",
  "excellent",
  "exceptional",
  "exquisite",
  "extraordinary",
  "fantastic",
  "fireworks",
  "first-class",
  "flawless",
  "glorious",
  "good",
  "gorgeous",
  "great",
  "greatest",
  "groovy",
  "impressive",
  "incredible",
  "legendary",
  "lovely",
  "magnificent",
  "majestic",
  "marvelous",
  "neat",
  "outstanding",
  "perfect",
  "phenomenal",
  "pioneering",
  "posh",
  "prime",
  "rad",
  "remarkable",
  "riveting",
  "sensational",
  "slick",
  "solid",
  "spectacular",
  "splendid",
  "strike",
  "stunning",
  "stupendous",
  "sublime",
  "super-duper",
  "super-excellent",
  "super",
  "superb",
  "surprising",
  "terrific",
  "tiptop",
  "top-notch",
  "unbelievable",
  "well done",
  "wonderful",
  "woop",
  "world-class",
  "wow",
  "yay",
  "yep",
])

export function randomWord() {
  return words[Math.floor(Math.random() * words.length)]
}
